import nestedSelect from './nested-select'
import filterToOptions from './filter-to-options'

export default {
    mixins: [nestedSelect, filterToOptions],
    props: {
        filtersData: {
            type: Object,
            default: () => {},
        },
        filterValues: {
            type: Object,
            default: () => {},
        },
        meta: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            visibleFilter: undefined,
            filters: [
                {
                    name: 'type',
                    title: 'Статус торгов',
                    type: 'radio',
                    value: [],
                    mobile: true,
                    makeSelectAll: true,
                    options: [
                        {
                            text: 'Объявленные',
                            value: 'auctions',
                        },
                        {
                            text: 'В агентировании',
                            value: 'agency',
                        },
                    ],
                },
                {
                    name: 'location',
                    title: 'Субъект РФ',
                    type: 'select-multiple',
                    value: [],
                    mobile: true,
                    options: [
                        {
                            text: 'Option 1',
                            childNodes: [
                                {
                                    text: 'Option 1.1',
                                    value: '1.1',
                                },
                                {
                                    text: 'Option 1.2',
                                    value: '1.2',
                                },
                            ],
                        },
                        {
                            text: 'Option 2',
                            childNodes: [
                                {
                                    text: 'Option 2.1',
                                    value: '2.1',
                                },
                                {
                                    text: 'Option 2.2',
                                    value: '2.2',
                                },
                            ],
                        },
                        {
                            text: 'Option 3',
                            value: '3',
                        },
                    ],
                },
                {
                    name: 'plot',
                    title: 'Вид объекта',
                    type: 'select-multiple',
                    value: [],
                    mobile: true,
                    options: [
                        {
                            text: 'Option 1',
                            value: '1',
                        },
                        {
                            text: 'Option 2',
                            value: '2',
                        },
                        {
                            text: 'Option 3',
                            value: '3',
                        },
                    ],
                },
                {
                    name: 'quarter',
                    title: 'Планируемый квартал',
                    type: 'select-multiple',
                    value: [],
                    mobile: true,
                    options: [
                        {
                            text: 'Option 1',
                            value: '1',
                        },
                        {
                            text: 'Option 2',
                            value: '2',
                        },
                        {
                            text: 'Option 3',
                            value: '3',
                        },
                    ],
                },
                {
                    name: 'subject',
                    title: 'Тип реализации',
                    type: 'select-multiple',
                    value: [],
                    mobile: true,
                    options: [
                        {
                            text: 'Option 1',
                            value: '1',
                        },
                        {
                            text: 'Option 2',
                            value: '2',
                        },
                        {
                            text: 'Option 3',
                            value: '3',
                        },
                    ],
                },
                {
                    name: 'area',
                    title: 'Площадь, м&sup2;',
                    type: 'minmax',
                    value: null,
                    mobile: true,
                    minValue: 200,
                    maxValue: 300,
                },
                {
                    name: 'price',
                    title: 'Стоимость, ₽',
                    type: 'minmax',
                    value: null,
                    mobile: true,
                    minValue: 200,
                    maxValue: 300,
                },
                {
                    name: 'share',
                    title: 'Аукционы за долю',
                    tooltip:
                        'Договор комплексного освоения территории, с обязательством передачи части помещений в ДОМ.РФ',
                    type: 'checkbox',
                    value: null,
                    mobile: false,
                },
                {
                    name: 'krt',
                    title: 'КРТ',
                    tooltip: 'Договор Комплексного Развития Территории',
                    type: 'checkbox',
                    value: null,
                    mobile: false,
                },
                {
                    name: 'search',
                    title: 'Номер аукциона, кадастровый номер или адрес',
                    type: 'text',
                    value: null,
                    mobile: false,
                },
                {
                    name: 'date',
                    title: 'Дата окончания приема заявок',
                    type: 'date',
                    value: [],
                    mobile: true,
                    auction: false,
                    range: false,
                },
                {
                    name: 'okn',
                    title: 'ОКН',
                    tooltip: 'Объект культурного наследия',
                    type: 'checkbox',
                    value: null,
                    mobile: false,
                },
            ],
            showAllFilters: false,
            isEmptyArea: false,
            isEmptyPrice: false,
        };
    },
    computed: {
        mobileFilters() {
            return this.filters.filter((item) => item.mobile);
        },
        activeFilters() {
            return this.filters
                .filter((item) => {
                    if (
                        ['select', 'select-multiple', 'date'].includes(
                            item.type
                        )
                    ) {
                        return !!item.value.length;
                    }
                    if (['radio'].includes(item.type)) {
                        return !Array.isArray(item.value);
                    }
                    if (['minmax'].includes(item.type)) {
                        if (
                            item.value &&
                            item?.maxValue === item?.value[1] &&
                            item?.minValue === item?.value[0]
                        ) {
                            return false;
                        }
                    }
                    return item.value !== null;
                })
                .map((item) => item.name);
        },
        emptyFilters() {
            return this.activeFilters.length < 1;
        },
        tabAllActive() {
            return (
                this.filters[0].value === null ||
                this.filters[0].value === undefined ||
                (Array.isArray(this.filters[0].value) &&
                    !this.filters[0].value.length) ||
                JSON.stringify(this.filters[0].value) ===
                    JSON.stringify(this.filters[0].options)
            );
        },
        tabOptionValues() {
            return this.filters[0].options.map((opt) => opt.value);
        },
    },
    watch: {
        filtersData: {
            immediate: true,
            deep: true,
            handler() {
                const path = document.location.pathname.match(/archive/);
                if (path !== null && path[0] === 'archive') {
                    this.filters[10].auction = true;
                    this.filters[10].title = 'Дата проведения торгов';
                    this.filters[10].range = true;
                }
                this.setFilterOptionsFromProps();
                if (
                    this.filtersData?.type?.values?.auctions === 'Объявленные'
                ) {
                    this.filters[10].range = true;
                }
            },
        },
        filterValues: {
            deep: true,
            handler() {
                this.$nextTick(() => {
                    this.setFilterValuesFromProps();
                });
            },
        },
    },
    methods: {
        getMobileFilters(noAgency = false) {
            if (noAgency) {
                return this.filters.filter((item) =>
                    item.name !== 'quarter' ? item.mobile : false
                );
            }
            return this.filters.filter((item) =>
                item.name !== 'date' ? item.mobile : false
            );
        },
        convertToMinMax(rowData) {
            const keys = Object.keys(rowData);
            const values = {};
            keys.forEach((key) => {
                Object.assign(values, rowData[key]);
            });

            return values;
        },
        showFilters() {
            this.showAllFilters = true;
        },
        showFilter(filter) {
            document.body.classList.add('body-lock-scroll');
            this.visibleFilter = filter;
        },
        clearAllFilters(
            withoutTypeFilter = false,
            needToSubmitData = true,
            needToSubmitFilters = false
        ) {
            if (this.$refs.dp) {
                this.$refs.dp.resetDate();
            }
            this.filters.forEach((item) => {
                if (
                    (withoutTypeFilter && item.name !== 'type') ||
                    !withoutTypeFilter
                )
                    this.clearFilter(item.name);
            });
            this.submitFilters(needToSubmitData, needToSubmitFilters);
        },
        clearMobileFilter(name) {
            this.clearFilter(name);
            this.submitFilters();
        },
        clearFilter(name) {
            const filter = this.filters.find((item) => item.name === name);
            if (
                ['select', 'select-multiple', 'radio', 'date'].includes(
                    filter.type
                )
            ) {
                filter.value = [];
            } else if (['minmax', 'text', 'checkbox'].includes(filter.type)) {
                filter.value = null;
            }
            if (filter.name === 'area') {
                this.isEmptyArea = true;
            }
            if (filter.name === 'price') {
                this.isEmptyPrice = true;
            }
        },
        closeFilter() {
            document.body.classList.remove('body-lock-scroll');
            this.visibleFilter = undefined;
        },
        setFilter(name, eventValue) {
            if (name === 'area') {
                this.isEmptyArea = false;
            }
            if (name === 'price') {
                this.isEmptyPrice = false;
            }
            const filterByName = this.filters.find(
                (item) => item.name === name
            );
            filterByName.value = eventValue;
        },
        setFilterOptionsFromProps(data = this.filtersData) {
            if (!data || !Object.keys(data)?.length) {
                return false;
            }

            this.filters.forEach((item) => {
                const itemFilterValues = data[item.name];
                if (itemFilterValues) {
                    this.setValuesToFilterByType(item.name, itemFilterValues);
                }
            });
        },

        /**
         * Находит фильтр по имени,
         * смотрит на его тип
         * и в зависимости от типа, устанавливает значения
         * @param name
         * @param rowData {Object} - сырые данные, полученные от бэка
         */
        setValuesToFilterByType(name, rowData) {
            const filter = this.filters.find((item) => item.name === name);
            if (['select', 'radio'].includes(filter.type)) {
                filter.options = this.convertToOption(rowData.values);
            }
            if (filter.type === 'select-multiple') {
                filter.options = this.convertToOption(
                    rowData.structure || rowData.values
                );
            }
            if (filter.type === 'minmax') {
                const parsedValues = this.convertToMinMax(rowData);
                if (parsedValues?.min || parsedValues?.max) {
                    filter.minValue = Number(parsedValues.min);
                    filter.maxValue = Number(parsedValues.max);
                }
            }
        },
        setFilterValuesFromProps() {
            if (!this.filterValues) {
                return;
            }
            const keys = Object.keys(this.filterValues);
            if (!keys?.length) {
                return false;
            }

            keys.forEach((item) => {
                const originalName = item.split('-')[0];
                const filter = this.filters.find(
                    (field) => field.name === originalName
                );
                if (filter) {
                    if (['text', 'checkbox'].includes(filter.type)) {
                        filter.value = this.filterValues[item];
                    }
                    if (['minmax'].includes(filter.type)) {
                        if (!filter.value) {
                            filter.value = [filter.minValue, filter.maxValue];
                        }
                        if (item.split('-')[1] === 'from') {
                            if (this.filterValues[item] >= filter.minValue)
                                filter.value[0] = this.filterValues[item];
                        }
                        if (item.split('-')[1] === 'to') {
                            if (this.filterValues[item] <= filter.maxValue)
                                filter.value[1] = this.filterValues[item];
                        }
                    }
                    if (['select', 'select-multiple'].includes(filter.type)) {
                        const linearOptions = this.getLinearItems(
                            filter.options
                        );
                        // const optionByValue = linearOptions.filter((option) => this.filterValues[item].includes(option.value));
                        const arr = [];
                        linearOptions.forEach((option) => {
                            if (Array.isArray(this.filterValues[item])) {
                                this.filterValues[item].forEach((el) => {
                                    if (
                                        el.includes(option.value) &&
                                        el.length === option.value.length
                                    ) {
                                        arr.push(option);
                                    }
                                });
                            } else if (
                                this.filterValues[item].includes(
                                    option.value
                                ) &&
                                this.filterValues[item].length ===
                                    option.value.length
                            ) {
                                arr.push(option);
                            }
                        });
                        const optionByValue = arr;
                        if (optionByValue) {
                            filter.value = optionByValue;
                        }
                    }
                    if (['radio'].includes(filter.type)) {
                        if (
                            Array.isArray(this.filterValues[item]) &&
                            this.filterValues[item].length > 1
                        ) {
                            filter.value = filter.options.filter((option) =>
                                this.filterValues[item].includes(option.value)
                            );
                        } else {
                            filter.value = filter.options.find(
                                (option) =>
                                    option.value === this.filterValues[item]
                            );
                        }
                    }
                }
            });
        },
        clearSearchValue(name, val) {
            this.setFilter(name, val);
            this.submitFilters();
        },
    },
};
